import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, from, Observable, take, tap } from 'rxjs';
import Swal, { SweetAlertResult } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertConfigugationService {
  private readonly translateService = inject(TranslateService);
  private readonly router = inject(Router);
  
  public openSignUpAdvertisementDialog(): Observable<SweetAlertResult<void>> {
    return from(
      Swal.fire({
        title: 'OWNRSCLB',
        text: this.translateService.instant('guestAdvertisement'),
        showCancelButton: true,
        confirmButtonText: this.translateService.instant('Signup'),
        cancelButtonText: this.translateService.instant('Cancel'),
      })
    )
      .pipe(
        take(1),
        filter(result => !!result && result.isConfirmed),
        tap(() => this.router.navigate(['/auth/signup'])),
      )
  }
}
